import React from "react";

function SurveyIcon2() {
  return (
    <svg
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    className="navIcon"

    >
      <path
        d="M29.417 1H3.583A2.586 2.586 0 001 3.583v25.834A2.586 2.586 0 003.583 32h25.834A2.586 2.586 0 0032 29.417V3.583A2.586 2.586 0 0029.417 1zM3.583 2.033h25.834c.855.001 1.549.695 1.55 1.55V7.2H2.033V3.583c.001-.855.695-1.549 1.55-1.55zm25.834 28.934H3.583a1.552 1.552 0 01-1.55-1.55V8.233h28.934v21.184a1.552 1.552 0 01-1.55 1.55z"
        fill="#fff"
        stroke="#fff"
      />
      <path
        d="M21.667 18.05H25.8c.57-.001 1.033-.463 1.033-1.034v-4.133c0-.57-.463-1.033-1.033-1.033h-4.133c-.57 0-1.033.463-1.034 1.033v4.133c.001.57.463 1.033 1.034 1.034zm0-5.167H25.8v4.133h-4.133v-4.133zM26.317 24.767a.517.517 0 00-.517.517v1.033h-4.133v-4.133h2.583a.517.517 0 000-1.034h-2.583c-.57.001-1.033.463-1.034 1.034v4.133c.001.57.463 1.033 1.034 1.033H25.8c.57 0 1.033-.463 1.033-1.033v-1.033a.517.517 0 00-.516-.517zM5.65 13.4h4.133a.517.517 0 100-1.034H5.65a.517.517 0 100 1.034zM18.05 12.366h-6.2a.517.517 0 000 1.034h6.2a.517.517 0 100-1.034zM5.65 17.533h6.2a.517.517 0 000-1.033h-6.2a.517.517 0 100 1.033zM18.05 16.5h-4.133a.517.517 0 100 1.033h4.133a.517.517 0 100-1.033zM5.65 22.7h4.133a.517.517 0 100-1.034H5.65a.517.517 0 100 1.033zM18.05 21.666h-6.2a.517.517 0 000 1.033h6.2a.517.517 0 100-1.033zM11.85 25.8h-6.2a.517.517 0 100 1.033h6.2a.517.517 0 000-1.033zM18.05 25.8h-4.133a.517.517 0 100 1.033h4.133a.517.517 0 100-1.033z"
        fill="#fff"
        stroke="#fff"
      />
      <path
        d="M26.937 20.323l-2.743 3.657-.612-.612a.517.517 0 00-.73.73l1.033 1.034a.516.516 0 00.778-.056l3.1-4.133a.517.517 0 10-.826-.62v0z"
        fill="#fff"
        stroke="#fff"
      />
    </svg>
  );
}

export default SurveyIcon2;
